/* eslint no-underscore-dangle: 0 react/no-this-in-sfc: 0 */

import React, { Component } from 'react';

/* eslint-disable */
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called'); } return call && (typeof call === 'object' || typeof call === 'function') ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError(`Super expression must either be null or a function, not ${typeof superClass}`); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* eslint-enable */

const AppSidebarToggler = ((_Component) => {
  _inherits(AppSidebarToggler, _Component);
  function AppSidebarToggler(props) {
    const _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.render = _this.render.bind(_this);
    return _this;
  }

  AppSidebarToggler.prototype.toggleSidebar = function toggleSidebar() {
    document.body.classList.toggle('sidebar-show');
  };

  AppSidebarToggler.prototype.render = function render() {
    // eslint-disable-next-line max-len
    const backgroundImage = 'url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB2aWV3Qm94PScwIDAgMzAgMzAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHBhdGggc3Ryb2tlPScjZjRmM2YzJyBzdHJva2Utd2lkdGg9JzIuMjUnIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcgc3Ryb2tlLW1pdGVybGltaXQ9JzEwJyBkPSdNNCA3aDIyTTQgMTVoMjJNNCAyM2gyMicvPjwvc3ZnPg==)';

    return (
      <button
        className='navbar-toggler sidebar-toggler d-lg-none mr-auto'
        type='button'
        data-toggle='sidebar-show'
        onClick={() => this.toggleSidebar()}
      >
        <span
          className='navbar-toggler-icon'
          style={{
            height: 23,
            backgroundImage
          }}
        />
      </button>
    );
  };

  return AppSidebarToggler;
})(Component);

export default AppSidebarToggler;
